export default "__VITE_ASSET__CmZuO$2s__"